import { computed } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import { useApplicationStandaloneStoreActions, useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import * as ApplicationStandaloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import { useGuestFillOutStoreActions, useGuestFillOutStoreGetters } from "@Client/@Modules/guest-fill-out/store/guest-fill-out-helpers";
import * as GuestFillOutActions from "@Client/@Modules/guest-fill-out/store/guest-fill-out-actions";
import * as GuestFillOutGetters from "@Client/@Modules/guest-fill-out/store/guest-fill-out-getters";
export const useLanguageSelector = options => {
  const {
    locale,
    t
  } = useI18n();
  const {
    withConfirmation
  } = options;
  const {
    UPDATE_LANGUAGE_PREFERENCE
  } = useApplicationStandaloneStoreActions([ApplicationStandaloneActions.UPDATE_LANGUAGE_PREFERENCE]);
  const {
    SET_LOADING
  } = useApplicationStandaloneStoreMutations([ApplicationStandaloneMutations.SET_LOADING]);
  const {
    LOAD_GUEST_FILL_OUT_LOCALE
  } = useGuestFillOutStoreActions([GuestFillOutActions.LOAD_GUEST_FILL_OUT_LOCALE]);
  const {
    SESSION_TOKEN
  } = useGuestFillOutStoreGetters([GuestFillOutGetters.SESSION_TOKEN]);
  const localeLanguageOptions = computed(() => ({
    "en-CA": {
      text: t("global.words.english"),
      shortVersion: "EN",
      id: "en-CA"
    },
    "fr-CA": {
      text: t("global.words.french"),
      shortVersion: "FR",
      id: "fr-CA"
    }
  }));
  const currentLocale = computed(() => localeLanguageOptions.value[locale.value]);
  const handleLanguageSelect = lang => {
    if (withConfirmation.value) {
      const confirm = window.confirm(t("global.messages.langSelectorChange").toString());
      if (!confirm) return;else handleLocaleChange(lang);
    } else {
      locale.value = lang;
      handleLocaleChange(lang);
    }
  };
  const handleLocaleChange = async localeLanguage => {
    SET_LOADING(true);
    await UPDATE_LANGUAGE_PREFERENCE({
      localeLanguage
    });
    if (SESSION_TOKEN.value) await LOAD_GUEST_FILL_OUT_LOCALE();
    SET_LOADING(false);
  };
  return {
    locale,
    localeLanguageOptions,
    currentLocale,
    handleLanguageSelect
  };
};